module.exports = __webpack_public_path__ + "static/LogoWhite-b9134570971bcb8648c64ae412f35744.png";